<template>
    <div>
        <div class="returnBtn-container">
            <div class="returnBtn__wrapper" @click="returnToMain">
                <div class="returnBtn__icon">
                    <img src="@/assets/icons/Menager_back_arrow.svg">
                </div>
                <div class="returnBtn__text">{{translate('ReturnBtn')}}</div>
            </div>
        </div>
        <div class="order-header">
            <div class="order-header__wrapper">
                <div class="order-header__content">
                    <div class="order-header__title">
                        {{translate('own_OrderStickerFrom')}}
                    </div>
                    <div class="order-header__subtitle">
                        {{translate('orderBannerSubtitle')}}
                    </div>
                    <a href="#order-select__header" class="order-header__link">
                        <div class="order-header__btn">
                            {{translate('orderPageBtn')}}
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="order-select" id="order-select">
            <div class="order-select__wrapper">
                <div class="order-select__header" id="order-select__header">
                    <div class="header-icon">
                        <img src="@/assets/icons/order_select_dots.svg">
                    </div>
                    <div class="header-title">
                        {{translate('orderSelectTitle')}}
                    </div>
                </div>
                <div class="order-select__list">
                    <div class="row">
                        <div class="list-row col-12" v-for="item in orderQuestions" :key="item.id">
                            <div class="list__wrapper" :class="{active: item.checked}">
                                <div class="list__content">
                                    <input class="sign-up__checkbox" :id="'Terms_' + item.id" name="" type="checkbox"
                                           v-model="item.checked" @change="onQuestionCheckChange()">
                                    <label class="checkbox-title" :for="'Terms_' + item.id" id="checkbox-text">{{item.text}}</label>
                                    <div class="list-info">
                                        <div class="list-info__business">
                                            <div class="business-site">
                                                {{translate('orderBusinessSite')}}:
                                            </div>
                                            <div class="business-site">
                                                {{translate('orderBusinessPlacement')}}:
                                            </div>
                                            <div class="business-site">
                                                ID:
                                            </div>
                                        </div>
                                        <div class="list-info__business-name">
                                            <div class="business-site__name">
                                                {{item.place_name}}
                                            </div>
                                            <div class="business-site__name" v-if="item.optional">
                                                {{item.optional}}
                                            </div>
                                            <div class="business-site__name" v-else>
                                                -
                                            </div>
                                            <div class="business-site__name">
                                                #{{item.id}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list-sticker__count">
                                    <div class="count__wrapper">
                                        <div class="count-minus" @click="stickerCountMinus(item)">
                                            <img src="@/assets/icons/order_minus.svg">
                                        </div>
                                        <div class="count-number">
                                            <input type="number" v-model="item.count" class="count-number__input"
                                                   min="0"
                                                   @input="checkInputValue($event, item)"
                                                   @blur="refreshTotalStickerCount"
                                                   @keyup="changeOnKeyup(item)"
                                            >
                                        </div>
                                        <div class="count-plus" @click="stickerCountPlus(item)">
                                            <img src="@/assets/icons/order_plus.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="delivery">
                <div class="delivery-block">
                    <div class="delivery-wrapper">
                        <div class="delivery-top__content">
                            <div class="delivery__icon">
                                <img src="@/assets/icons/ic_box.svg">
                            </div>
                            <div class="delivery__title">
                                {{translate('orderShippingBlockTitle')}}
                            </div>
                        </div>
                        <div class="owner-filter">
                            <div class="owner-filter__bottom">
                                <div class="range">
                                    <div class="range-select">
                                        <div class="dropdown-range">
                                            <label>{{translate('orderCountryLabel')}}*</label>
                                            <b-dropdown class="m-2" no-caret :text="selectedCountry.name">
                                                <b-dropdown-item v-for="item in shippingCountries" :key="item.name"
                                                                 v-on:click="onCountrySelected(item)">
                                                    <span>{{item.name}}</span>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div class="range">
                                    <div class="range-select">
                                        <div class="dropdown-range">
                                            <label>{{translate('orderStickerSizeLabel')}}*</label>
                                            <b-dropdown class="m-2" no-caret :text="stickerSize.display">
                                                <b-dropdown-item v-for="item in pricing.stickerSizes.options" :key="item"
                                                                 v-on:click="onStickerSizeSelected(item)">
                                                    <span>{{item}}{{pricing.stickerSizes.value}}</span>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-content__phone">
                                    <md-field
                                            ref="phoneField"
                                            class="active phone-custom md-has-value"
                                            :class="{'md-invalid': $v.profile.phone.$dirty && $v.profile.phone.$invalid}"
                                    >
                                        <label>{{translate('bi_Phone')}}*</label>
                                        <vue-tel-input
                                                required
                                                id="tooltip-phone"
                                                placeholder=""
                                                v-model="profile.phone"
                                                :inputOptions="{showDialCode: true}"
                                                @input="onInputPhoneField"
                                                @blur="onBlurPhoneField"
                                        ></vue-tel-input>
                                        <span class="md-error">{{ translate('bi_validation_Phone') }}</span>
                                    </md-field>
                                </div>
                                <div class="order-content__mail">
                                    <md-field :class="{'md-invalid': $v.profile.email.$dirty && $v.profile.email.$invalid}">
                                        <label>{{translate('bi_ContactEmail')}}*</label>
                                        <md-input
                                                v-model="profile.email"
                                                type="email"
                                                @input="checkValidation">
                                        </md-input>
                                        <span class="md-error">{{translate('ThereIsAnError')}}</span>
                                    </md-field>
                                </div>
                                <div class="order-content__mail">
                                    <md-field>
                                        <label>{{translate('own_Comment')}}</label>
                                        <md-input
                                                v-model="profile.comment"
                                                :maxlength="100"
                                                type="email">
                                        </md-input>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list-check">
                        <div class="list-check__wrapper"></div>
                        <div class="list-check__scure">
                                <div class="scure__content" v-for="item in orderPoints" :key="item.id">
                                    <div class="scure__content-display" v-if="item.show">
                                        <div>
                                            <div class="content-title">
                                                {{item.text}}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="content-count">
                                                {{item.value}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="scure-border"></div>
                                <div class="scure-content__wrapper" :class="{show: !hasShippingPricing() || this.totalStickerCount >= 3000}">
                                    <div class="scure__content">
                                        <div class="content-title">
                                            {{translate('orderTotal')}}
                                        </div>
                                        <div class="content-price">
                                            {{totalPriceFormatted()}}
                                        </div>
                                    </div>
                                    <div class="paypal-button">
                                        <div class="paypal-button__wrapper"
                                             :class="{disabled: orderFieldCheck()}">
                                            <div id="paypal-button-container" class="paypal-button-container"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="shipping__massage" v-if="!hasShippingPricing() || this.totalStickerCount >= 3000">
                                    <div class="massage__wrapper">
                                        <div class="massage__content">
                                            <div class="massage__content-icon">
                                                <img src="@/assets/icons/ic_directions.svg">
                                            </div>
                                            <div class="massage__content-text">
                                                <div class="content-text__title">
                                                    {{translate('orderShippingTitle')}}
                                                </div>
                                                <div class="content-text__subtitle">
                                                    {{translate('orderShippingSubtitle')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="shipping__massage-btn" :class="{disabled: orderFieldCheck()}" @click="getQuote">
                                        {{translate('orderQuote')}}
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {MdField} from 'vue-material/dist/components'
    import '@/assets/css/MdField.css'
    import {validationMixin} from 'vuelidate'
    import errorMixin from '@/mixins/errorMixin';
    import {isPhoneValid, phoneValidator} from '@/helpers/customValidators';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import {VueTelInput} from 'vue-tel-input'
    import Vue from "vue";
    import countries from '@/store/countries';

    const {email} = require('vuelidate/lib/validators')

    Vue.use(MdField)

    export default {
        name: "orderPage",

        mixins: [errorMixin, validationMixin],
        validations: {
            profile: {
                phone: {
                    phone: phoneValidator
                },
                email: {
                    email
                }
            }
        },

        data() {
            return {
                profile: {
                    phone: '',
                    email: '',
                    comment: '',
                },
                pricing: {
                    stickerPriceList: {},
                    shippingPriceList: {},
                    stickerSizes: [],
                    currency: {}
                },
                stickerSize: {
                    value: null,
                    display: '_'
                },
                totalStickerPrice: 0,
                orderQuestions: [],
                shippingCountries: countries,
                selectedCountry: countries.find(item => item.code == 'US'),
                orderPoints: {
                    "stickers": {
                        text: this.translate('admin_Stickers'),
                        value: 0,
                        show: true,
                        id: 1
                    },
                    "delivery": {
                        text: this.translate('orderDelivery'),
                        value: 0,
                        show: true,
                        id: 2
                    },
                },
                totalStickerCount: 0,
            }
        },
        components: {
            VueTelInput
        },
        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            }),
        },

        async mounted() {
            await this.getQuestions()
            this.setCountryByIp()
            let thiz = this
            paypal.Buttons({
                createOrder: function (data, actions) {
                    return thiz.createOrder(thiz.createOrderInfo()).then(function (res) {
                        console.log(`createOrder response:`, res)
                        return res.order_id;
                    }).catch((error) => {
                        console.log('createOrder error:', error)
                        thiz.showErrorModal(`some error: ${JSON.stringify(error.data)}`)
                    })
                },
                onApprove: function (data, actions) {
                    let item = {
                        order_id: data.orderID
                    }
                    return thiz.captureOrder(item).then(function (res) {
                        console.log(`captureOrder response:`, res)
                        thiz.onOrderCreated(true)
                    }).catch((error) => {
                        console.log('captureOrder error:', error)
                        thiz.showErrorModal(`some error: ${JSON.stringify(error.data)}`)
                    })
                }
            }).render('#paypal-button-container');
            this.profile.email = this.userInfo.contact_email;
            this.profile.phone = this.userInfo.phone;
        },
        methods: {
            ...mapActions({
                getQuestionsByOrgAction: 'organization/fetchQuestionsByOrganization',
                createOrder: 'payment/createOrder',
                captureOrder: 'payment/captureOrder',
                getPricing: 'payment/getPricing',
                getUserIP: 'payment/getUserIP',
                getCountryByIp: 'payment/getCountryByIp'
            }),
            async getStickerPrice() {
                try {
                    const response = await this.getPricing({countryCode: this.selectedCountry.code})
                    this.pricing.stickerPriceList = response.pricing
                    this.pricing.shippingPriceList = response.shipping
                    this.pricing.stickerSizes = response.sizes
                    this.pricing.currency = response.currency
                    this.stickerSize.value = response.sizes.options[0]
                    this.stickerSize.display = response.sizes.options[0] + this.pricing.stickerSizes.value
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            async getQuestions() {
                try {
                    const response = await this.getQuestionsByOrgAction({});
                    let qrs = response.qrs;
                    for (let i = 0; qrs.length > i; i++) {
                        qrs[i].count = 0
                    }
                    this.orderQuestions = qrs
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            createOrderInfo() {
                return {
                    "recipient_phone": this.profile.phone,
                    "recipient_email": this.profile.email,
                    "comment": this.profile.comment,
                    "country_code": this.selectedCountry.code,
                    "sticker_size": this.stickerSize.value,
                    "questions": this.getCheckedQuestions()
                }
            },
            async getQuote() {
                try {
                    const response = await this.createOrder(this.createOrderInfo())
                    this.onOrderCreated(false)
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            async setCountryByIp() {
                try {
                    const response = await this.getCountryByIp()
                    for (let i = 0; this.shippingCountries.length > i; i++) {
                        if (this.shippingCountries[i].code.toLowerCase() == response.country_code.toLowerCase()) {
                            this.selectedCountry = this.shippingCountries[i]
                        }
                    }
                } catch (error) {
                    this.selectedCountry = this.countries.find(item => item.code == 'US')
                }
                await this.getStickerPrice();
                this.orderPoints.delivery.show = this.hasShippingPricing()
            },
            onOrderCreated(paid) {
                this.$router.push({name: 'orderSuccess', query: {paid: ''+paid}})
            },
            onBlurPhoneField() {
                let validate = this.profile.phone.replace(/[' ']/g, '').replace(/-/g, '')
                if (isPhoneValid(validate)) {
                    this.$refs.phoneField.$el.classList.remove('md-invalid')
                } else {
                    this.$refs.phoneField.$el.classList.add('md-invalid')
                }
            },
            checkValidation() {
                this.$v.profile.$touch()

                if (!this.$v.profile.$invalid) {
                    this.saveDisable = false
                } else {
                    this.saveDisable = true
                }
            },
            orderFieldCheck() {
                return this.totalStickerCount == 0 || this.$v.profile.email.$invalid || this.$v.profile.phone.$invalid || this.profile.phone == '' || this.profile.email == ''
            },
            checkInputValue(e, item) {
                item.count = Math.max(0, parseInt(e.target.value) || 0);
            },
            onInputPhoneField(value, obj) {
                this.currentPhoneCountry = `+${obj.country.dialCode}`
                this.$v.profile.phone.$touch()
                this.checkValidation()
            },
            onQuestionCheckChange() {
                this.refreshTotalStickerCount()
            },
            getCheckedQuestions() {
                return this.orderQuestions
                    .filter(item => item.checked && item.count > 0)
                    .map(item => {
                        return {
                            uid: item.uid,
                            count: item.count,
                            text: item.text
                        }
                    })
            },
            refreshTotalStickerCount() {
                let totalCount = 0
                for (let i = 0; this.orderQuestions.length > i; i++) {
                    if (this.orderQuestions[i].checked) {
                        if (this.orderQuestions[i].count == 0) this.orderQuestions[i].count = 1
                        totalCount += +this.orderQuestions[i].count
                    }
                }
                this.totalStickerCount = totalCount
                this.orderPoints.stickers.value = totalCount
                if (this.totalStickerCount == 0) this.orderPoints.delivery.value = 0
                this.refreshTotalPrice()
            },
            refreshTotalPrice() {
                let price = 0.0
                let shippingPrice = 0.0
                for (const [key, value] of Object.entries(this.pricing.stickerPriceList)) {
                    if (this.totalStickerCount <= key) {
                        price = value[this.stickerSize.value];
                        break
                    }
                }
                for (const [key, value] of Object.entries(this.pricing.shippingPriceList)) {
                    if (this.totalStickerCount <= key) {
                        shippingPrice = value[this.stickerSize.value]
                        break
                    }
                }
                if (this.totalStickerCount == 0) {
                    this.orderPoints.delivery.value = 0
                    this.totalStickerPrice = 0
                } else {
                    let sPrice = `${shippingPrice}`
                    if (this.pricing.currency.position == 'before') {
                        sPrice = `${this.pricing.currency.value}${sPrice}`
                    } else {
                        sPrice = `${sPrice}${this.pricing.currency.value}`
                    }
                    this.orderPoints.delivery.value = sPrice
                    this.totalStickerPrice = ((this.totalStickerCount * price) + shippingPrice).toFixed(2)
                }
            },
            changeOnKeyup(item) {
                item.checked = true
                this.refreshTotalStickerCount()
            },
            stickerCountPlus(item) {
                item.count++
                item.checked = true
                this.refreshTotalStickerCount()
            },
            stickerCountMinus(item) {
                if (item.count > 0) item.count--
                if (item.count == 0) item.checked = false
                this.refreshTotalStickerCount()
            },
            returnToMain() {
                this.$router.push({name: 'OwnerPlaceManagement'})
            },
            async onCountrySelected(item) {
                this.selectedCountry = item
                await this.getStickerPrice();
                this.orderPoints.delivery.show = this.hasShippingPricing()
                this.refreshTotalStickerCount()
            },
            async onStickerSizeSelected(item) {
                this.stickerSize.value = item
                this.stickerSize.display = item + this.pricing.stickerSizes.value
                this.refreshTotalPrice()
            },
            totalPriceFormatted() {
                let price = `${this.totalStickerPrice}`
                if (this.pricing.currency.position == 'before') {
                    price = `${this.pricing.currency.value}${price}`
                } else {
                    price = `${price}${this.pricing.currency.value}`
                }
                return price
            },
            hasShippingPricing() {
              return Object.keys(this.pricing.shippingPriceList).length > 0
            },
        }
    }


</script>
<style>
    html {
        scroll-behavior: smooth;
    }
</style>
<style scoped>
    .order-header {
        margin-top: 40px;
    }

    .order-header__wrapper {
        /*filter: drop-shadow(0px 2px 14px rgba(0, 0, 0, 0.106042));*/
        border-radius: 6px;
        background-color: rgba(63, 64, 92, 1);
        position: relative;
    }

    .order-header__wrapper::after {
        content: '';
        background-image: url("~@/assets/images/order_header_image.png");
        background-repeat: no-repeat;
        background-size: cover;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        border-radius: 6px;

    }

    .order-header__content {
        padding-top: 64px;
        padding-left: 48px;
        padding-bottom: 56px;
    }

    .order-header__title {
        font-size: 32px;
        line-height: 48px;
        color: #FFFFFF;
        padding-right: 15px;
        position: relative;
        z-index: 9999;
    }

    .order-header__subtitle {
        padding-top: 20px;
        font-size: 20px;
        line-height: 32px;
        color: #FFFFFF;
        width: 512px;
        position: relative;
        z-index: 9999;
    }

    .order-header__btn {
        margin-top: 28px;
        padding: 12px 35px;
        background: #FFBF00;
        box-shadow: 0px 2px 6px rgba(255, 191, 0, 0.72);
        border-radius: 6px;
        max-width: 250px;
        position: relative;
        z-index: 9999;
        cursor: pointer;
        text-align: center;
    }

    .order-header__link {
        text-decoration: none;
        color: #2F2F2F;
        outline: none;
    }

    .order-header__link:hover {
        outline: none;
        text-decoration: none;
    }

    .vti__dropdown-list {
        z-index: 10 !important;
    }

    .order-select {
        margin-top: 40px;
        display: flex;
    }

    .order-select__wrapper {
        border-radius: 6px;
        background: #3F405C;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.106042);
        padding-top: 27px;
        padding-left: 24px;
        width: 808px;
        height: fit-content;
    }

    .order-select__header {
        display: flex;
        align-items: center;
    }

    .header-title {
        padding-left: 16px;
        font-size: 18px;
        line-height: 28px;
        color: #FFBF00;
    }

    .order-select__list {
        margin-top: 25px;
    }

    .list__wrapper {
        position: relative;
        padding-top: 18px;
        padding-left: 18px;
        margin-bottom: 32px;
        width: 100%;
        background: linear-gradient(180deg, #73759B 0%, #67688D 100%);
        box-sizing: border-box;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.205092);
        border-radius: 4px;
        margin-right: 32px;
        transition: 0.5s linear;
    }

    .list__wrapper.active {
        background: #32324B;
        box-shadow: inset 0px 3px 9px rgba(0, 0, 0, 0.24);
        transition: 0.5s linear;
    }

    .list-row {
        display: flex;
    }
    .sign-up__checkbox {
        position: absolute;
        height: 100%;
        width: 100%;
    }
    .dropdown-range label {
        position: relative;
        color: #6D6D6D;
        padding-left: 0;
        opacity: 0.8;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        margin-bottom: 0 !important;
        cursor: default;
        position: absolute;
        width: 100%;
        color: #ffffff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-left: 30px;
        padding-right: 15px;
        text-align: start;
        cursor: pointer;
    }

    label .checkbox-title {
        padding-left: 25px;
    }

    label.checkbox-title:before {
        content: " ";
        color: #000;
        display: inline-block;
        font: 15px/20px FontAwesome;
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;
        background: linear-gradient(180deg, #73759B 0%, #67688D 100%);
        height: 22px;
        width: 22px;
        border: 2px solid #FFBF00;
        border-radius: 3px;
        transition: 0.5s linear;
    }

    input:checked + label.checkbox-title:before {
        content: "\2714";
        background: #FFBF00;
        transition: 0.5s linear;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .list-info__business {
        display: flex;
        padding-left: 30px;
        flex-direction: column;
        justify-content: space-between;
    }

    .list-info {
        padding-top: 35px;
        display: flex;
    }

    .business-site {
        font-size: 16px;
        line-height: 24px;
        color: #FFFFFF;
        opacity: 0.8;
        font-style: normal;
        font-weight: normal;
    }

    .business-site__name {
        padding-left: 14px;
        padding-right: 14px;
        padding-top: 3px;
        font-size: 16px;
        font-style: normal;
        font-weight: normal;
        color: #FFFFFF;
        opacity: 0.8;
        word-break: break-all;
        max-width: 500px;
    }

    .list-sticker__count {
        height: 32px;
        margin-bottom: 16px;
        margin-left: 29px;
        margin-top: 9px;
        display: flex;
        position: relative;
        z-index: 999999;
    }

    .count__wrapper {
        display: flex;
        align-items: center;
        background: rgba(196, 196, 196, 0.1);
        border-radius: 81px;
    }

    .count-minus {
        padding-left: 6px;
        padding-right: 17px;
        cursor: pointer;
    }

    .count-number {
        color: #FFFFFF;
    }

    .count-plus {
        padding-left: 17px;
        cursor: pointer;
        padding-right: 6px;
    }

    .delivery-wrapper {
        width: 448px;
        background: #FFFFFF;
        padding: 28px 26px 25px 24px;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.106042);
        border-radius: 6px;
        margin-left: 24px;
    }

    .delivery-top__content {
        display: flex;
        align-items: center;
    }

    .delivery__title {
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #2F2F2F;
        padding-left: 16px;
    }

    .owner-filter__bottom .range-select {
        width: 100% !important;
    }

    .owner-filter__bottom .range .dropdown-range {
        background: none !important;
        width: 100% !important;
        padding: 5px 0px 15px 0px;
    }

    .owner-filter__bottom .dropdown.btn-group.b-dropdown.m-2 {
        width: 100% !important;
    }

    .owner-filter__bottom .range .dropdown-menu {
        width: 100% !important;
        max-height: 250px !important;
    }

    .owner-filter__bottom .range .dropdown:before {
        height: 2px !important;
    }
    .owner-filter__bottom .range .range-select .dropdown-range {
        margin-right: 5px !important;
    }
    .owner-filter__bottom .range .dropdown button.btn-secondary {
        padding-top: 0;
    }

    .md-field.md-focused label,
    .md-field.md-has-value label {
        pointer-events: auto;
        top: 0;
        opacity: 0.8;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }

    .md-field:after {
        height: 2px;
        background-color: #3F405C;
        z-index: 0;
    }

    .vue-tel-input {
        border: none;
        width: 100%;
    }

    .vue-tel-input:focus-within {
        box-shadow: none;
    }

    .order-payment__image img {
        width: 464px;
        margin-right: 64px;
    }

    .order-content__phone, .order-content__mail {
        padding-right: 5px;
    }

    .order-content__phone label {
        position: absolute;
        color: #6D6D6D;
        padding-left: 0;
        height: auto;
    }

    .order-content__mail label {
        position: absolute;
        color: #6D6D6D;
        padding-left: 0;
        top: 19px;
        height: auto;
    }

    .content-image img {
        width: 464px;
        height: 264.05px;
    }

    .list-check {
        width: 100%;
        margin-top: 32px;
        padding-bottom: 32px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .list-check__wrapper {
        background: #2F2F2F;
        border-radius: 48px;
        height: 24px;
        position: relative;
        margin-left: 25px;
    }

    .list-check__scure {
        width: 400px;
        background: #FFFFFF;
        position: relative;
        margin-top: -10px;
        margin-left: 50px;
        margin-right: 25px;
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 15px;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.106042);
    }

    .list-check__scure::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: -7px;
        right: 0;
        background-repeat: repeat;
        height: 10px;
        background-size: 20px 20px;
        background: linear-gradient(29deg, transparent 33.333%, #FFFFFF 33.333%, #FFFFFF 66.667%, transparent 66.667%), linear-gradient(-29deg, transparent 33.333%, #FFFFFF 33.333%, #FFFFFF 66.667%, transparent 66.667%);
        background-size: 17px 20px;
        background-position: 0 -10px;

    }

    .scure__content {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        padding-bottom: 5px;
    }
    .scure__content-display {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
    }
    .scure-border {
        height: 2px;
        background: #2F2F2F;
        border-radius: 33px;
        margin-top: 5px;
    }

    .content-price {
        font-size: 16px;
        line-height: 32px;
        color: #1976D2;
    }

    .returnBtn-container {
        margin-top: 55px;
    }

    .paypal-button-container {
        display: flex;
        justify-content: center;
        max-width: 100%;
    }

    .paypal-button__wrapper.disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed !important;
    }
    .shipping__massage-btn.disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed !important;
    }
    .paypal-button {
        display: flex;
        justify-content: center;
        padding-bottom: 20px;
        margin-top: 15px;
    }

    .paypal-button__wrapper {
        width: 100%;
    }

    .massage__wrapper {
        margin-top: 14px;
        margin-bottom: 15px;
        padding: 16px;
        background: rgba(74, 145, 250, 0.1);;
        border-radius: 6px;
    }

    .massage__content {
        display: flex;
    }

    .massage__content-text {
        margin-left: 19px;
    }

    .massage__content-icon img {
        min-width: 27px;
    }

    .content-text__title {
        font-size: 14px;
        line-height: 22px;
        font-weight: 600;
    }

    .content-text__subtitle {
        font-size: 14px;
        line-height: 22px;
        font-style: normal;
        font-weight: 400;
    }

    .shipping__massage-btn {
        background: #FFBF00;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 12px;
        padding-bottom: 12px;
        box-shadow: 0px 2px 6px rgba(255, 191, 0, 0.72);
        border-radius: 6px;
        cursor: pointer;
    }

    .count-number__input {
        width: 100%;
        max-width: 35px;
        background: rgba(196, 196, 196, 0);
        color: white;
        text-align: center;
    }

    .count-number__input:focus {
        outline: none;
        border: none;
    }

    .scure-content__wrapper.show {
        display: none;
    }
    .content-count.show {
        display: none;
    }
    @media screen and (max-width: 1250px) {
        .order-select__wrapper {
            width: 740px;
        }
    }

    @media screen and (max-width: 1000px) {

        .order-select {
            display: flex;
            flex-direction: column;
        }

        .delivery-block {
            display: flex;
        }

        .order-select__wrapper {
            width: 100%;
        }

        .delivery-wrapper {
            width: 100%;
            margin-left: 0;
            margin-top: 25px;
        }
        .list-check__scure {
            width: auto;
        }
    }

    @media screen and (max-width: 981px ) {
        .order-payment__image img {
            margin-right: 20px;
        }
    }

    @media screen and (max-width: 778px ) {
        .list-row {
            flex-direction: column;
        }

        .list__wrapper {
            width: auto;
        }

        .business-site__name {
            max-width: 350px;
        }

        .order-payment__image img {
            display: none;
        }

        .delivery-block {
            flex-direction: column;
        }

        .list-check__wrapper {
            margin-left: 0;
        }

        .list-check__scure {
            width: auto;
            margin-left: 30px;
        }

        .order-header__subtitle {
            width: auto;
        }

    }

    @media screen and (max-width: 536px) {
        .order-header__wrapper::after {
            background-image: url("~@/assets/images/order_header_image_mobile.png");
        }
    }

    @media screen and (max-width: 426px ) {
        .order-content__mail, .order-content__phone {
            padding-left: 0px;
            padding-right: 0;
        }

        .owner-filter__bottom .range .dropdown:before {
            height: 3px !important;
        }

        .owner-filter__bottom .range .dropdown-range {
            padding-right: 0 !important;
            padding-left: 0 !important;
            margin-right: 0 !important;
        }

        .owner-filter__bottom .dropdown.btn-group.b-dropdown.m-2 {
            margin-left: 0 !important;

        }

        .header-title {
            padding-right: 15px;
        }

        .order-header__content {
            padding-left: 15px;
        }

        .order-header__subtitle {
            width: auto;
            padding-right: 15px;
        }

        .paypal-button-container {
            max-width: 335px;
        }

        .delivery-wrapper {
            padding-right: 20px;
        }
        .list-info  {
            padding-top: 75px;
        }
    }

    @media screen and (max-width: 376px ) {
        .list-info__business {
            padding-left: 0;
        }

        .owner-filter__bottom .range .dropdown:before {
            height: 2px !important;
        }

        .list-sticker__count {
            margin-left: 0;
        }

        .paypal-button-container {
            max-width: 315px;
        }

        .order-content__wrapper {
            margin-left: 5px;
        }
    }

    @media screen and (max-width: 321px) {
        .paypal-button-container {
            max-width: 255px;
        }

    }


</style>